/**
 * Wire shapes for the rules store (ncoder-backend, `/api/orgs/:organization_id/rules`).
 * Typed by hand, like the org-admin endpoints: these shapes are not in the weave contracts.
 */

/** GUI-facing scope. `org` is ORG_RULES.md, `mine` is MY_RULES.md. */
export type RulesScope = 'org' | 'mine';

export interface RulesDocument {
  /** Version 0 with `content === null` means never written; `template` then holds the starter text. */
  version: number;
  content: string | null;
  /** Starter template: set only when `version === 0 && content === null`, null otherwise. */
  template: string | null;
  updated_at: string | null;
  updated_by_user_id: string | null;
}

export interface RulesDocuments {
  org: RulesDocument;
  /** The caller's own file (`scope = 'user'` on the server). */
  mine: RulesDocument;
  /** Server cap on one file, in bytes. */
  max_bytes: number | null;
}

/** Text to show (and to treat as the saved baseline): the content, else the starter template. */
export function rulesDisplayText(doc: Pick<RulesDocument, 'content' | 'template'>): string {
  return doc.content ?? doc.template ?? '';
}

export interface RulesVersion {
  version: number;
  content: string;
  author_user_id: string | null;
  created_at: string | null;
}

export interface SaveRulesBody {
  content: string;
  base_version: number;
}

/** Server clamp on the versions list. */
export const RULES_VERSIONS_MAX_LIMIT = 50;
